<template>
  <div class="wrap">
    <div class="header">
      <div class="header-top">
        <img src="../images/ico_next_l@2x.png" @click="backLastPage" style="cursor: pointer" />
        <h3 class="title">{{this.query.course_name }}</h3>
      </div>
      <div class="header-bottom">
        <div>班期：{{this.query.class_name }}</div>
        <div>章节：{{this.query.chapter_id?this.query.chapter_name:this.query.section_name}}</div>
      </div>
    </div>
    <div class="option">
      <el-button :class="status==1?'active':''" @click="changeOption(1)">待完成 {{showTotal}}</el-button>
      <el-button :class="status==2?'active':''" @click="changeOption(2)">已完成 {{compete}}</el-button>
      <el-button :class="status==3?'active':''" @click="changeOption(3)">草稿箱 {{drafts}}</el-button> 
    </div>
    <div class="course-content">
      <table class="table">
        <tr class="table-header" :style="status==2?'grid-template-columns: 27fr 18fr 18fr 13fr 13fr 13fr':''">
          <th>作业名称</th>
          <th>发布时间</th>
          <th>截止时间</th>
          <th v-if="status == 1 || status == 3">题目数量</th>
          <th v-else-if="status == 2">批改状态</th>
          <th v-if="status == 2">是否迟交</th>
          <th>操作</th>
        </tr>
        <tr v-for="item of homeworkDetailList" :key="item.qt_id" :style="status==2?'grid-template-columns: 27fr 18fr 18fr 13fr 13fr 13fr':''">
          <td>{{ item.name }}</td>
          <td>{{item.release_time }}</td>
          <td>{{item.end_time }}</td>
          <td :class="status == 2?item.status == 1?'unread':'read':''">{{ status == 1 || status == 3?item.sum:item.status == 1?'待批阅':'已批阅' }}</td>
          <td v-if="status == 2" style="font-size:12px;">{{isLate(item.create_time,item.end_time)}}</td>
          <td v-if="status == 1" style="color:#1872ED; font-size:12px;cursor:pointer" @click="toQuestionPaperPage(item,'do')">写作业</td>
          <td v-else style="color:#1872ED; font-size:12px;cursor:pointer"  class="operate">
            <span v-if="status == 2 && item.status == 2" @click="toQuestionPaperPage(item,'check')">{{item.status == 1?'查看详情':'查看评语'}}</span>
            <span v-if="status == 2 && item.status == 1" @click="toQuestionPaperPage(item,'edit')">修改作业</span>
            <span v-if="status == 3 && item.status == 1" @click="toQuestionPaperPage(item,'edit')">写作业</span>
          </td>
        </tr>
      </table>
    </div>
    <div class="pagination">
      <el-pagination background  :current-page.sync="page" @current-change="handleCurrentChange" layout="total, prev, pager, next, jumper" :total="total"></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      seachKey:'',
      pagination: {
        page: 1,
        total: 0,
        num: 6,
      },
      status:1,
      page:1,
      homeworkDetailList:[],
      total:0,
      showTotal:'',
      drafts: '',
      compete: ''
    }
  },
  props:{
    query:{
      type:Object,
      default(){
        return{}
      }
    }
  },
  computed:{
    isLate(){
      return function(create_time,end_time){
        if(new Date(create_time).getTime()>new Date(end_time).getTime()){
          return '迟交'
        }else{
          return '未迟交'
        }
      }
    }
  },
  created() {
    console.log(this.query.activeName)
    this.status = this.query.activeName || 1
    this.showTotal = this.query.unFinished || 0
    this.getHomeWorkDetailList()
  },
  methods: {
    handleCurrentChange(val){
      this.page = val
      this.getHomeWorkDetailList()
    },
    backLastPage(){
      this.$emit('changePage',{page:'HomeworkList'})
    },
    async getHomeWorkDetailList(){
      const {course_id,
          class_id,
          chapter_id,
          section_id} = this.query
      const data = {
        page:this.page,
        page_nums:10,
        course_id,
        class_id,
        chapter_id,
        section_id
      }
      if(this.status == 2) {
        data.flag = 0
      }else if (this.status == 3) {
        data.flag = 1
      }
      const api = this.status == 1?'/user/index/not':'/user/index/already'
      const res = await this.$axios.post(api,data)
      if(res.data.code == 200){
        this.homeworkDetailList = res.data.data.chapter_question
        // if(this.status == 1){
        //   this.showTotal = res.data.data.count
        // }
        if (res.data.data.incomplete != undefined) {
          this.showTotal = res.data.data.incomplete // 待完成
          this.compete = res.data.data.compete // 已完成
          this.drafts = res.data.data.drafts // 草稿箱
          if(this.status === 1){
            this.total = res.data.data.incomplete 
          }else if(this.status === 2){
            this.total = res.data.data.compete
          }else{
            this.total = res.data.data.drafts
          }
        }
      }
    },
    changeOption(val){
      this.status = val
      this.page = 1
      this.getHomeWorkDetailList()
    },
    toQuestionPaperPage(item,type){
      console.log('gsssssssss-----', item)
      const payload = {...this.query,...item,...{type},...{activeName:this.status},...{unFinished:this.showTotal}}
      this.$emit('changePage',{page:'QuestionPaper',query:payload})
    }
  },
}
</script>

<style lang="scss" scoped>
li,
ul,
p,
h4 {
  margin: 0;
  padding: 0;
  list-style: none;
}
th{
  font-weight: normal;
}
.wrap {
  background: #ffffff;
  margin: 25px 0px 25px 25px;
  float: left;
  padding: 20px 30px;
  min-height: 880px;
  .header{
    padding-bottom: 17px;
    border-bottom: 1px solid #e8eaec;
    .header-top{
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      img{
        width: 20px;
        height: 20px;
        margin-right: 10px;
      }
    }
    .header-bottom{
      display: flex;
      font-size: 14px;
      color: #808695;
      margin-left: 30px;
      div{
        margin-right: 30px;
      }
    }
  }
}
.title {
  font-size: 20px;
  color: #202020;
}
.option{
  margin-top: 16px;
  ::v-deep .el-button{
    border: none;
    background: #eff2f5;
    color: #202020;
    font-size: 14px;
    border-radius: 17px;
    padding: 6px 23px;
    font-size: 14px;
    line-height: 20px;
  }
  ::v-deep .el-button.active{
    background: #1872ED;
    color: #ffffff;
  }
}
.course-content {
  margin-top: 20px;
  padding: 0 20px 0 0;
  box-sizing: border-box;
  font-size: 14px;
  max-height: 650px;
  overflow-y: auto;
  .table{
    width: 100%;
    border: 1px solid #e8eaec;
    border-collapse:collapse

  }
  .table .read{
    font-size: 12px;
    color: #202020;
  }
  .table .unread{
    font-size: 12px;
    color: #FFAB1B;
    }
  tr{
      width: 100%;
      display: grid;
      grid-template-columns: 27fr 18fr 18fr 13fr 13fr;
      justify-content: center;
      align-items: center;
      min-height: 50px;
      th{
        border-right: 1px solid #e8eaec;
        height: 100%;
        line-height: 50px;
        border-bottom: 1px solid #e8eaec;

      }
      th:last-child{
        border-right: none;
      }
      td{
        border-right: 1px solid #e8eaec;
        border-bottom: 1px solid #e8eaec;
        height: 100%;
        display: flex;
        text-align: center;
        justify-content: center;
        align-items: center;
      }
      td:last-child{
        border-right: none;
      }
  }
  tr:first-child th{
    border-bottom: none;
  }
  tr:last-child td{
    border-bottom: none;
  }
  .table-header{
      background: #F5F6F7;
      color: #808695;
  }
}
.pagination {
  display: flex;
  width: 100%;
  justify-content: center;
  margin-top: 20px;
}
.pagination >>> .el-pager li:not(.disabled).active {
  background: #10a675;
}
.operate{
  display: flex;
  flex-direction: column;
}
.operate span:nth-child(2){
  margin-top: 8px;
}


</style>
